export default {"src":"/_next/static/media/next-arrow-step-three-image.600475a5.svg","height":70,"width":71,"blurWidth":0,"blurHeight":0};